import upcomingMudules from './upcoming-modules.json';

const dataSet = {
  upcomingMudules,
};

export default dataSet;
